import React, { useEffect, useState } from "react";
import { ReactComponent as BackArrow } from "../Icons/BackArrow.svg";
import { ReactComponent as AlertIcon } from "../Icons/ErrorAlert.svg";
import {
  StyledErrorTypography,
  StyledPrimaryTypography,
  StyledSecondaryTypography,
} from "../Theme";
import {
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { showToast } from "../CommonComponents/Toaster";

const ForgotPassword = ({
  email,
  setEmail,
  setDisplayScreen,
  setIsForgotPassword,
}) => {
  const dispatch = useDispatch();
  const { loginStatus, verifyEmailStatus } = useSelector(
    (state) => state.Login
  );
  const [errorText, setErrorText] = useState("");
  console.log("render forgot password", errorText);
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [loadingBtn, setLoadingBtn] = useState(false);

  const handleEmail = (e) => {
    let { value } = e.target;
    setEmail(value);
    setErrorText("");
  };
  const handleSingUp = async () => {
    let isError = validateEmail();
    if (!isError) {
      setLoadingBtn(true);
      const forgotPasswordData = { email: email };
      await axios
        .post(
          `${process.env.REACT_APP_API_URL}forgot_password`,
          forgotPasswordData,
          {
            headers: { device_type: 1 },
          }
        )
        .then((response) => {
          setIsForgotPassword(true);
          setDisplayScreen("otp");
        })
        .catch((err) => {
          console.log("forgot password error", err);
          setErrorText(err?.response.data.error);
        })
        .finally(() => {
          setLoadingBtn(false);
        });
    }
  };

  const validateEmail = () => {
    let isError = false;
    if (email === "") {
      setErrorText("Error! No input detected.");
      isError = true;
    } else if (emailRegex.test(email) === false) {
      setErrorText("Enter valid email.");
      isError = true;
    }
    return isError;
  };
  return (
    <>
      <BackArrow
        style={{ cursor: "pointer" }}
        onClick={() => setDisplayScreen("login")}
      />
      <StyledPrimaryTypography sx={{ mt: 2 }}>
        Recover Password
      </StyledPrimaryTypography>
      <StyledSecondaryTypography>
        Please enter your email address below.
      </StyledSecondaryTypography>
      <TextField
        value={email}
        onChange={handleEmail}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {errorText !== "" && <AlertIcon />}
            </InputAdornment>
          ),
        }}
        sx={{
          mt: 3,
          mb: 2,
          "& .MuiInputBase-root": {
            color: errorText === "" ? "#111927" : "#912018",
          },
          backgroundColor: errorText === "" ? "#F9FAFB" : "#FEE4E2",
        }}
      />
      {errorText && <StyledErrorTypography>{errorText}</StyledErrorTypography>}
      <Button
        disabled={loadingBtn}
        onClick={handleSingUp}
        fullWidth
        variant="contained"
      >
        {loadingBtn ? <CircularProgress size={25} /> : "Set up now"}
      </Button>
    </>
  );
};

export default ForgotPassword;
